
import axios from 'axios';


const WooCheckoutAPI = {









async getCheckoutExpress(base_url) {


  const currentTime = new Date();
  const n = currentTime.getTime();

    //console.log("API get_variationIds");
    //const apiURL = `${base_url}/wp-json/woo-order-cart/v1/data_ips_checkoutexpress`;
    const url = `${base_url}/?wc-ajax=ips_get_expresscheckout&nocache=${n}`;
    
  
    const data = {
      search: "Testdata",
  };
  
    try {
    
      const response = await axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      // || -- || -- || -- || -- || -- || -- || -- || -- || -- ||
  
      if (response.status === 200) {
        const responseData = response.data;
        console.log('Response Data - CheckoutExpress:', responseData);
 
        return responseData;
      } else {
        throw new Error('Network response was not ok.');
      }
    } catch (error) {
      console.error('There was a problem with the Axios operation:', error);
      throw error;
    }
 


}






  // Weitere Funktionen für API-Aufrufe hier hinzufügen...
};





export default WooCheckoutAPI;